import React, { Component } from 'react';
import './DrugDetailsPage.css';
import Page from '../../components/page/Page';
import models from '../../model/models';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import Button from '../../components/button/Button';
import history from '../../history';
import Volume from '../../components/volume/Volume';
import LabelAndValue from '../../components/labelAndValue/LabelAndValue';
import DiscrepancyPopup from '../../popups/discrepancyPopup/DiscrepancyPopup';
import UpdateDrugPopup from '../../popups/updateDrugPopup/UpdateDrugPopup';
import Map from '../../components/map/Map';
import toasts from '../../utils/toasts';
import mainAPI from '../../api/MainAPI';
import CardHeader from '../../components/cardHeader/CardHeader';
import Row from '../../components/row/Row';
import utils from '../../utils/utils';
import HeaderRow from '../../components/headerRow/HeaderRow';
import DrugHistoryCard from '../../cards/drugHistoryCard/DrugHistoryCard';
import { getDisplayUnit } from '../../utils/gramUtils';

export default class DrugDetailsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			codeError: false,
			codeTouched: false,
			update: false,
			drug: {},
			updatedDrug: {
				type: null,
				barcode_id: null,
				drug_box_id: null,
				lot_number: null,
				expiration_date: null,
				amount: null
			},
			canDelete: false,
		};
	}

	componentDidMount = () => {
		this.subscribeId = models.drug.onChange(this._getDrugData);
	};

	componentWillUnmount = () => {
		models.drug.unsubscribe(this.subscribeId);
	};

	_getDrugData = async () => {
		const {match: {params: {id} = {}} = {}} = this.props;
		const {canDelete, reason} = await mainAPI.drug.canDelete(id) || {};

		let drug = models.drug.obj(id);
		if (drug) {
			drug.stock_move_record__quantity = Volume.inPreferredUnit(drug.stock_move_record__quantity, drug.type);
			this.myRefs = { ...drug };
			this.setState({
				drug,
				updatedDrug: drug,
				canDelete
			});
		}
		this._getTransferData();
	};

	_getTransferData = async () => {
		const id = this.props.match.params.id;
		let transfers = await mainAPI.drug_transfer.for_drug(id);
		this.setState({ transfers });
	};

	_showDeleteModal = () => {
		window.popupController.show(DiscrepancyPopup, {
			title: 'Are you sure you want to delete this drug?',
			notesPlaceholder: 'Why are you removing this?',
			onComplete: this._deleteDrug,
			id: this.props.match.params.id
		});
	};

	_deleteDrug = async (drug) => {
		models.drug.delete(drug.id, drug.notes).then((success) => {
			if (!success) toasts.show('Could not delete drug', 5000);
		});
		window.popupController.hide(DiscrepancyPopup);
		history.navigate('/drugs');
		return true;
	};

	_showUpdateModal = () => {
		window.popupController.show(UpdateDrugPopup, { drug: this.state.drug });
	};

	_renderMap = () => {
		return null;
		let practiceCoords = [
			{ lat: 40.249999, lng: -111.6499974 },
			{ lat: 40.248999, lng: -111.6449974 },
			{ lat: 40.247999, lng: -111.6459974 },
			{ lat: 40.245999, lng: -111.6479974 }
		];
		return (
			<Card className="g-drug-details-page-content-component-map">
				<div className="g-drug-details-page-header">
					<Label black large className="g-drug-details-page-content-header">
						Drug Map History
					</Label>
				</div>
				<div className="g-drug-details-page-content">
					<Map coords={practiceCoords} />
				</div>
			</Card>
		);
	};
	renderTransferList = () => {
		let transfers = this.state.transfers;
		if (!transfers) return null;
		let columns = [
			{ label: 'Transferred by' },
			{ label: 'Transferred on' },
			{ label: 'From box' },
			{ label: 'To box' }
		];
		let display = [<HeaderRow columns={columns} />];
		for (let i in transfers) {
			display.push(
				<Row key={i}>
					<Label> {transfers[i].user_name}</Label>
					<Label> {utils.display_actual_datetime(transfers[i].created_on)}</Label>
					<Label> {transfers[i].from_box_name}</Label>
					<Label> {transfers[i].to_box_name}</Label>
				</Row>
			);
		}
		return display;
	};

	render() {
		const deleteButton = () => {
			const {canDelete = false} = this.state;
			if (!canDelete) return null;
			return (<Button
				className="g-drug-details-page-delete-button"
				color="white"
				bg="red"
				onClick={this._showDeleteModal}
			>Delete</Button>);
		}

		const {
			update,
			drug: {
				id,
				barcode_id = '-',
				expiration_date,
				last_checked_by_id = '-',
				last_checked_on,
				stock_move_record__quantity = '-',
				lot_number,
				ndc_barcode,
				drug_box__name,
				type = '-'
			} = {}
		} = this.state;
		const drugType = models.drug_type.obj(type) || '';
		return (
			<Page className="g-drug-details-page">
				{update && this._renderUpdateModal()}
				<Card className="g-drug-details-page-content-component">
					<div className="g-drug-details-page-header">
						<CardHeader>Drug Details</CardHeader>
						<div className="g-drug-details-page-buttons">
							<Button
								className="g-drug-details-page-delete-button"
								color="white"
								bg="blue"
								onClick={this._showUpdateModal}
							>
								Edit
							</Button>
							{ deleteButton() }
						</div>
					</div>
					<div className="g-drug-details-page-content">
						<div className="g-drug-details-page-content-left">
							<LabelAndValue label="Type" value={drugType.name || utils.capitalize(type).replace(/_/g, ' ')} />
							<LabelAndValue label="Code" value={barcode_id} />
							<LabelAndValue label="Drug Box" value={drug_box__name} />
							<LabelAndValue label="Volume" value={stock_move_record__quantity + ' ' + getDisplayUnit(type)} />
						</div>
						<div className="g-drug-details-page-content-right">
							<LabelAndValue
								label="Last Check"
								value={last_checked_on ? utils.display_actual_datetime(last_checked_on) : '-'}
							/>
							<LabelAndValue label="Lot Number" value={lot_number} />
							<LabelAndValue label="Expires on" value={expiration_date ? utils.display_date(expiration_date) : '-'} />
							{ndc_barcode && <LabelAndValue label="NDC Barcode" value={ndc_barcode} />}
						</div>
					</div>
				</Card>
				{this._renderMap()}
				<Card className="transfers">
					<CardHeader>Box Transfers</CardHeader>
					{this.renderTransferList()}
				</Card>
				<DrugHistoryCard drugId={id} type={type} />
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/drugDetailsPage/DrugDetailsPage.jsx